module.exports = __webpack_public_path__ + "static/img/product7.d0e0efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product7.png
// module id = c5HE
// module chunks = 1